import { Box, Card, CardMedia, Chip, Rating, Typography, Button, Grid } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../hooks/useAppReducer";
import StarIcon from "@mui/icons-material/Star";
import { CustomIconButton } from "./CustomIconButton";
import { addCommasToNumber } from "../helpers/commaSeparatedPrice";
import { clearPackageDetails } from "../features/holidayPackage/packageDetail";
import { colors } from "../styles/colors";
import { generateUniqueSessionId } from "../helpers/randomSessionId";
import platinumLogo from "../assets/images/platinum-logo.png";
import { roundPrice, roundPriceTransfers } from "../helpers/RoundPrice";
import { setDialogState } from "../features/dialog/dialogSlice";
import { setFlightRoomState } from "../features/flightRoom/flightRoomSlice";
import { setStepperState } from "../features/stepper/stepperSlice";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "../helpers/isEmpty";
import { setHolidayDetailsState } from "../features/holidaySummary/holidaySummarySlice";
import { addSpace } from "../helpers/addSpace";
import Image from "./Image";
import { getSessionStorage, removeSessionStorage, setSessionStorage } from "../helpers/storage";
import { ApplicationStateType } from "../features/store";
import { sortRoom } from "../helpers/sortRoom";
import { RoomMealWrapper } from "../helpers/roomMealWrapper";
import { capitalizeFirstLetterEachWords } from "../helpers/capitalizeFirstLetterEachWords";
import { calculatePerPersonPrice } from "../helpers/calculatePerPersonPrice";
import { calculateTotalPackagePrice } from "../helpers/calculateTotalPackagePrice";
import { isDiscountValidDate } from "../helpers/isDiscountValidDate";
import { formatPrice } from "../helpers/formatPrice";
import { setIsRetrieveBasketApiCall } from "../features/commonState";
import { ReactComponent as LocationIconBlack } from "../assets/icons/LocationIconBlack.svg";
import { ReactComponent as CalenderIcon } from "../assets/icons/CalenderIcon.svg"
import { ReactComponent as AiroplaneIcon } from "../assets/icons/AiroplaneIcon.svg"
import { ReactComponent as InclusiveIcon } from "../assets/icons/InclusiveIcon.svg"
import { ReactComponent as GalleryIcon } from "../assets/icons/GalleryIcon.svg"
import CardContent from '@mui/material/CardContent';
import dayjs from "dayjs";
import useWindowWidth from '../hooks/useWindowWidth';
import Slider from 'react-slick';
import TripAdvisorImage from "../assets/icons/tripadvisor.svg";
interface PackageCardProps {
  item?: any;
  psw_result_id: number;
  psw_result_id_combo: number;
  elementRef?: any;
  viewMode?: string;
  index?: number;
}

export const CircleRating = ({ value, maxCircles = 5 }) => (
  // <Tooltip title={value}>
  <Box display="flex" gap={"4px"} alignItems="center">
    <Image src={TripAdvisorImage} style={{ height: "28px", width: "auto" }} />
    {/* // 32px */}
    <Box display="flex" gap={"1px"} alignItems="center">
      {[...Array(maxCircles)].map((_, i) => {
        const isFull = i + 1 <= value;
        const isHalf = i < value && i + 1 > value;

        return (
          <Box
            key={i}
            sx={{
              width: 14, // 18
              height: 14,
              borderRadius: "50%",
              bgcolor: isFull ? "#33aa6b" : "transparent",
              border: `2px solid #33aa6b`,
              position: "relative",
              overflow: "hidden",
              ...(isHalf && {
                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: `${Math.min(1, Math.max(0, value - i)) * 100}%`, //'50%',
                  // width: `${value * 10}%`,//'50%',
                  height: "100%",
                  bgcolor: "#33aa6b",
                  left: 0,
                },
              }),
            }}
          />
        );
      })}
    </Box>
  </Box>
  // </Tooltip>
);

//! States
export const PackageCard = ({
  item,
  psw_result_id,
  psw_result_id_combo,
  elementRef,
  viewMode = "grid",
  index = 0,
}: PackageCardProps) => {
  const { dialogState } = useAppSelector((state) => state.dialog);
  const { stepper } = useAppSelector((state) => state.stepper);
  const { flightRoom } = useAppSelector((state) => state.flightRoom);
  const { holiday } = useAppSelector((state) => state.holidaySummary);
  const { filters } = useAppSelector((state) => state.filters);
  const { holidayPackage } = useAppSelector((state: ApplicationStateType) => state.holidayPackage);
  const { hotelDetails, tripHotelDetails } = useAppSelector((state) => state.hotelDetails);
  const {
    flightRoom: {
      searchCriteria: { guest, adults, childrens },
    },
  } = useAppSelector((state) => state.flightRoom);

  /**
   * @Variables
   */
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const data: any = JSON.parse(JSON.stringify(item?.SearchResult));
  const isEqual = data?.hotel_id === flightRoom?.hotel_id;
  let { hotel_rating, platinumHotel, hotel_classification } = item.HotelInfo;
  const { setSession_id } = useAuth();
  const signForPricing = process.env.REACT_APP_CURRENCY_SYMBOL
  const windowWidth = useWindowWidth();
  // TripAdvisor details fetched per hotel (HotelComponent attaches these)

  let rating =
    hotel_classification === "2"
      ? Number(hotel_rating) + 0.5
      : Number(hotel_rating);
  //* Guests count excluding infants
  const totalGuests = Number(
    flightRoom.searchCriteria.adults + flightRoom.searchCriteria.childrens
  );

  //! Functions

  useEffect(() => {
    sortRoom(data, filters);
  }, [filters?.holidayType, data]);

  const flightPrice: any = useMemo(() => {
    let price: any = 0
    const flightPrice = getSessionStorage("stepper") === "0" ? "0" : flightRoom.diffPrice || "0"

    if (getSessionStorage("nextAndSelectedFlights") === "false") {
      price = Math.ceil(flightPrice)
    } else {
      if (flightPrice.includes("-")) {
        price = Math.floor(flightPrice);
      } else {
        price = Math.ceil(flightPrice)
      }
    }
    return price
  }, [flightRoom.diffPrice, getSessionStorage("nextAndSelectedFlights")])

  const packagePrice = useMemo(() => {
    let price = 0;
    if (stepper === 0) {
      if (sortRoom(data, filters).length > 0) {
        sortRoom(data, filters).map((f: any) => {
          price = price + Number(f.total_package);
          return <></>;
        });
      }
    } else {
      if (data.hotel_id !== flightRoom.hotel_id) {
        if (sortRoom(data, filters).length > 0) {
          sortRoom(data, filters).map((f: any) => {
            price = price + Number(f.total_package);
            return <></>;
          });
        }
      } else {
        if (flightRoom.multiRooms.length > 0) {
          flightRoom.multiRooms.map((f: any) => {
            price = price + Number(f.total_package);
            return <></>;
          });
        }
      }
    }
    const getTransfer: any =
      stepper === 0
        ? isEmpty(data?.transfer?.pagedata[0]?.Transfer)
        : isEqual
          ? isEmpty(holiday?.transfer)
          : isEmpty(data?.transfer?.pagedata[0]?.Transfer);

    const tPrice = (getTransfer?.cust_tot_sell_amt ? parseFloat(getTransfer?.cust_tot_sell_amt) : 0)
    // const tPrice = (getTransfer?.cust_tot_sell_amt ? (parseFloat(getTransfer?.cust_tot_sell_amt) * parseFloat(getTransfer?.exchange_rate)) : 0)
    const transferPrice = roundPriceTransfers(tPrice, flightRoom.searchCriteria.isAdditionalTransferAmountAdd, totalGuests, flightRoom, data?.transfer?.pagedata[0]?.Transfer?.exchange_rate || 0)
    const addedFlightPrice = getSessionStorage("stepper") === "0" ? 0 : flightPrice

    const transfer_add = !flightRoom?.searchCriteria?.destination?.default_transfer ? transferPrice : 0
    // const totalPrice = (price + transfer_add) / totalGuests;
    const totalPrice = (price) / totalGuests;
    // return stepper === 0 ? roundPrice(String(totalPrice)) : data.hotel_id !== flightRoom.hotel_id ? roundPrice(String(totalPrice)) : roundPrice(String(totalPrice + addedFlightPrice))
    const unroundedPrice =
      stepper === 0
        ? totalPrice
        : data.hotel_id !== flightRoom.hotel_id
          ? totalPrice
          : totalPrice + addedFlightPrice;

    const roundedPrice = roundPrice(String(unroundedPrice));

    return {
      roundedPrice,
      unroundedPrice,
    };
    // eslint-disable-next-line
  }, [
    sortRoom(data, filters),
    flightRoom.multiRooms,
    flightRoom.hotel_id,
    data,
    totalGuests,
    holiday?.transfer,
    isEqual,
    stepper,
    flightPrice
  ]);
  const { roundedPrice, unroundedPrice } = packagePrice;

  const getRoomIds = (arr: any) => {
    const roomsArr: any = arr.map((e: any) => e.id);
    let passengerDetails: any = {};

    let totalPassenger = [...Array(adults + childrens)].map((value, index) =>
      (index + 1).toString()
    );

    roomsArr.map((r: any, i: any) => {
      const totalLength = guest[i].adults + guest[i].children.length;

      const totalPassengerPerRoom = [];

      for (let i = 0; i < totalLength; i++) {
        totalPassengerPerRoom.push(totalPassenger[i]);
      }

      totalPassenger.splice(0, totalLength);
      return (passengerDetails[r] = totalPassengerPerRoom.join(","));
    });
    return roomsArr.toString();
  };

  const queryData = useMemo(() => {
    const search = window.location.search
    const urlSearchParams = new URLSearchParams(search);
    const queryData: any = {};
    urlSearchParams.forEach((value, key) => {
      queryData[key] = value;
    });
    return queryData
  }, [])
  const handleMoreDetails = () => {
    dispatch(setIsRetrieveBasketApiCall(false));
    dispatch(setStepperState(1));
    dispatch(setDialogState({ ...dialogState, mapDialog: false }));
    dispatch(clearPackageDetails());
    const multiRoomIds = getRoomIds(sortRoom(data, filters));

    dispatch(
      setHolidayDetailsState({
        ...holiday,
        transfer: flightRoom?.searchCriteria?.destination?.default_transfer ?
          stepper === 0
            ? isEmpty(data.transfer) !== ""
              ? data.transfer?.pagedata[0]
              : flightRoom.selectedTransfer
            : isEqual
              ? flightRoom.selectedTransfer
              : data.transfer?.pagedata[0] : null,
      })
    );

    if (stepper === 0) {
      removeSessionStorage("basketId")
      setSessionStorage("previous", "false");
      setSessionStorage("nextButtonClicked", "false");
      setSessionStorage("nextAndSelectedFlights", "false");
      setSessionStorage("newHotelClick", "null")
      removeSessionStorage("OutboundFlights")
      removeSessionStorage("InboundFlights")
    } else {
      setSessionStorage("newHotelClick", "true")
      if (data.hotel_id !== flightRoom.hotel_id) {
        removeSessionStorage("basketId")
        setSessionStorage("previous", "false");
        setSessionStorage("nextAndSelectedFlights", "false");
        setSessionStorage("nextButtonClicked", "false");
      } else {
        setSessionStorage("nextButtonClicked", "true");
        setSessionStorage("nextAndSelectedFlights", "true");
        setSessionStorage("previous", "true")
      }
    }

    setSessionStorage("stepper", stepper.toString())
    setSessionStorage("more-details-click", "true");

    // console.log("ISSUE---38")
    dispatch(
      setFlightRoomState({
        ...flightRoom,
        callHolidaySummaryApi: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? true : false,
        confirmSelection: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? {
          flights: false,
          room: false,
          transfer: false,
        } : flightRoom.confirmSelection,
        selectedFlights:
          stepper === 0
            ? { inbound: [], outbound: [] }
            : data.hotel_id !== flightRoom.hotel_id ? { inbound: [], outbound: [] } : flightRoom.selectedFlights,
        psw_result_id: stepper === 0 ? psw_result_id : flightRoom.store_psw_result_id,
        psw_result_id_combo: stepper === 0 ? psw_result_id_combo : flightRoom.psw_result_id_combo,
        store_psw_result_id: stepper === 0 ? psw_result_id : flightRoom.store_psw_result_id,
        psc_request_id: stepper === 0 ? holidayPackage.flightSearchCriteriaId : flightRoom.psc_request_id,
        roomids: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? multiRoomIds : flightRoom.roomids,
        hotel_id: data.hotel_id,
        diffPrice: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? '0' : flightRoom.diffPrice,
        holidayDetailLogId: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? "0" : flightRoom.holidayDetailLogId,
        transferBody:
          stepper === 0
            ? isEmpty(data.transferSearchBody) !== ""
              ? data.transferSearchBody
              : flightRoom.transferBody
            : isEqual
              ? flightRoom.transferBody
              : data.transferSearchBody,
        selectHotelId: data.id,
        searchCriteriaId: data.searchCriteriaId,
        transfer:
          stepper === 0
            ? data.transfer === null || isEmpty(data.transfer) !== ""
              ? data.transfer
              : flightRoom.transfer
            : isEqual
              ? flightRoom.transfer
              : data.transfer,
        selectedTransfer: flightRoom?.searchCriteria?.destination?.default_transfer ?
          stepper === 0
            ? data.transfer === null || isEmpty(data.transfer) !== ""
              ? data.transfer?.pagedata[0]
              : flightRoom.selectedTransfer
            : isEqual
              ? flightRoom.selectedTransfer
              : data.transfer?.pagedata[0] : null,
        storeTransfer: flightRoom?.searchCriteria?.destination?.default_transfer ?
          stepper === 0
            ? data.transfer === null || isEmpty(data.transfer) !== ""
              ? data.transfer?.pagedata[0]
              : flightRoom.selectedTransfer
            : isEqual
              ? flightRoom.selectedTransfer
              : data.transfer?.pagedata[0] : null,
        search_result_id: data.id,
        multiRooms: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? sortRoom(data, filters) : flightRoom.multiRooms,
        storeMultiRoom: (stepper === 0 || (data.hotel_id !== flightRoom.hotel_id)) ? sortRoom(data, filters) : flightRoom.storeMultiRoom,
        cheapestFlightPSW:
          holidayPackage?.FlightDetails?.outbound?.flights[0]?.psw_result_id,
        // initialPackagePrice: roundedPrice,
        initialPackagePrice: packagePrice,
        roomData: null,
      })
    );

    const session_id = generateUniqueSessionId();
    setSession_id(session_id);
    dispatch(setDialogState({ ...dialogState, hotelInfoDialog: false }))
    navigate(`/holiday-summary/${session_id}${window.location.search}`);
  };

  const formatRoomType = (inputString: any) => {
    // Replace '&amp;' with '&'
    const formattedString = inputString?.replace('&amp;', '&');
    // Capitalize the first letter of each word
    const words = formattedString?.toLowerCase().split(' ');
    const capitalizedWords = words?.map((word: any) => word?.charAt(0).toUpperCase() + word?.slice(1));
    return capitalizedWords?.join(' ');
  };

  // Slider Code Start
  const [current, setCurrent] = React.useState(0);
  // slider settings
  const ListSliderSettings = {
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: false,       // IMPORTANT: prevents collapse
    beforeChange: (oldIndex, newIndex) => setCurrent(newIndex),
  };

  const [currentSlide, setCurrentSlide] = React.useState(0);
  const MAX_DOTS = 5;
  const capitalizeFirst = (text = "") =>
    text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase();

  const GridSliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,

    beforeChange: (_current: number, next: number) => {
      setCurrentSlide(next);
    },

    appendDots: (dots: React.ReactNode[]) => {
      // if dots are 5 or less → show all
      if (dots.length <= MAX_DOTS) {
        return <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>;
      }

      // sliding window logic
      let start = currentSlide - Math.floor(MAX_DOTS / 2);

      if (start < 0) start = 0;
      if (start + MAX_DOTS > dots.length) {
        start = dots.length - MAX_DOTS;
      }

      const visibleDots = dots.slice(start, start + MAX_DOTS);

      return <ul style={{ margin: 0, padding: 0 }}>{visibleDots}</ul>;
    },

    customPaging: i => (
      <div
        style={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          background: "rgba(255,255,255,0.7)",
        }}
      ></div>
    ),
  };

  // Slider Code End

  // let gridCardWidth = windowWidth < 1024 ? "100%" : "320px";

  // if (windowWidth > 1024 && windowWidth <= 1150) {
  //   const minWindow = 1024;
  //   const maxWindow = 1150;
  //   const minWidth = 320;
  //   const maxWidth = 380;

  //   const w = Math.min(Math.max(windowWidth, minWindow), maxWindow);

  //   const width =
  //     minWidth + ((w - minWindow) * (maxWidth - minWidth)) /
  //     (maxWindow - minWindow);

  //   gridCardWidth = `${Math.round(width)}px`;
  // } else if (windowWidth > 1350) {
  //   gridCardWidth = "325px"
  // } else if (windowWidth > 1255) {
  //   gridCardWidth = "300px"
  // } else if (windowWidth > 1200) {
  //   gridCardWidth = "280px"
  // } else if (windowWidth > 1150) {
  //   gridCardWidth = "260px"
  // }

  return (
    <>
      {viewMode === "list" ? (
        <Card
          sx={{
            borderRadius: '10px',
            boxShadow: "none",
            border: `1px solid ${colors.border.grey}`,
            display: { xs: "block", lg: "flex" },
            width: '100%',
            marginTop: { xs: "0px", sm: "0" },
            marginBottom: { xs: "10px", lg: "20px" },
            // Alternate background color based on index (even = white, odd = transparent)
            backgroundColor: index % 2 === 0 ? colors.basics.white : "transparent",
          }}
          className="mt-3"
        >
          <Box sx={{
            position: "relative",
            overflow: "hidden",
            width: { xs: "100%", lg: "320px", xl: "400px" },
          }}>

            {/* Slider Code Start */}
            {data?.VendorImages?.length > 0 ? (
              <>
                <Slider {...ListSliderSettings}>
                  {data?.VendorImages?.map((img, i) => (
                    <Box key={i} sx={{ height: "100%" }}>
                      <Image
                        src={img?.VendorImage?.printed_image_url || "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif"}
                        alt={`image-${i}`}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src =
                            "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif";
                        }}
                        style={{
                          width: "100%",
                          height: windowWidth > 600 ? "100%" : "186px",          // crucial: fill the slide height
                          objectFit: "cover",
                          display: "block",
                          // borderTopLeftRadius: 4,
                          // borderBottomLeftRadius: windowWidth > 600 ? 4 : 0,
                        }}
                      />
                    </Box>
                  ))}
                </Slider>
                {
                  data?.VendorImages.length > 1 && (
                    <Box sx={{
                      position: "absolute",
                      bottom: "12px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      background: "rgba(255,255,255,0.9)",
                      padding: "3px 10px",
                      borderRadius: "5px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontFamily: "Raleway",
                      fontSize: "12px",
                      fontWeight: 600,
                    }}>
                      <GalleryIcon />
                      <Typography fontSize="12px" fontWeight={600}>
                        {current + 1}/{data?.VendorImages?.length}
                      </Typography>
                    </Box>
                  )
                }
              </>
            ) : (
              <CardMedia
                className="package-card-img btn-olb-view-hotel"
                component="img"
                image={
                  data?.image_name ||
                  "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif"
                }
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src =
                    "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif";
                }}
                alt={data?.hotel_name}
                onClick={() => {
                  handleMoreDetails()
                }}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadiusLd: "10px", borderRadiusRd: "10px"

                }}
              />
            )}

            {/* Slider Code End */}
            <Box
              sx={{
                position: "absolute",
                top: "10px",
                left: "10px",
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
              }}
            >
              {data?.offerDetails &&
                data?.offerDetails?.length > 0 &&
                (() => {
                  const uniqueSubTitles = new Set<string>(); // To track unique subtitles
                  return data?.offerDetails?.slice(0, 2).map((d: any, i: number) => {
                    if (d?.subTitle && !uniqueSubTitles.has(d?.subTitle)) {
                      uniqueSubTitles.add(d.subTitle); // Add to the set
                      const offerText = addSpace(d?.subTitle);
                      const truncatedText = offerText && offerText?.length > 36
                        ? offerText.substring(0, 36) + '...'
                        : offerText;
                      return (
                        <Box key={i}>
                          <Chip
                            label={
                              <Typography
                                variant="subtitle1"
                                color={Number(platinumHotel) !== 0 ? ` ${colors.basics.plataniumGreenColor} !important` : ` ${colors.basics.primary} !important  `}
                                fontSize={"12px !important"}
                                fontWeight={500}
                                lineHeight={"1.2"}
                                sx={{
                                  padding: "6px"
                                }}
                              >
                                {capitalizeFirst(truncatedText)}
                              </Typography>
                            }
                            sx={{
                              background: colors.basics.white,
                              border: Number(platinumHotel) !== 0 ? `1px solid ${colors.basics.plataniumGreenColor}` : `1px solid ${colors.basics.primary}  `,
                              height: "auto",
                              "& .MuiChip-label": { p: 0 },
                              borderRadius: "100px!important",
                            }}
                          />
                        </Box>
                      );
                    }
                    return <React.Fragment key={i}></React.Fragment>; // Render nothing for duplicates
                  });
                })()}
            </Box>


          </Box>
          <Box ml={{ xs: 0, lg: "19px" }} flex={1} m={{ sm: "16px 24px", xs: "24px 16px 16px 16px" }}>
            <Box display={"flex"} flexDirection={{ xs: "column", sm: "row" }} justifyContent="space-between">
              <Box order={{ xs: 2, sm: 1 }}
              //  mt={{ lg: 2, xs: "10px" }}
              >
                <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
                  <Typography
                    sx={{
                      cursor: "pointer",
                      textTransform: "capitalize",
                      '&:hover': {
                        textDecoration: "underline",
                        color: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor : colors.basics.primary,
                        textTransform: "capitalize"
                      },
                    }}
                    className='btn-olb-view-hotel'
                    onClick={() => handleMoreDetails()}
                    lineHeight={"1.2"}
                    variant="h1"
                    fontSize={{ sm: "26px", xs: "22px" }}
                    dangerouslySetInnerHTML={{ __html: capitalizeFirstLetterEachWords(isEmpty(data?.hotel_name)) }}
                  />

                </Box>

                <Box display="flex"
                  flexDirection="row"
                  alignItems="center"
                  gap={{ sm: 2, xs: 1 }}
                  mt="5px">
                  {isEmpty(item.HotelInfo.resort_name) !== "" &&
                    <Box
                      display={{ xs: "flex", sm: "flex", lg: "flex" }}
                      alignItems={"center"}
                      order={{ xs: 1, sm: 2 }}
                      gap={1}
                      sx={{
                        textAlign: { xs: "left", sm: "left", lg: "left" },
                        // mt: { lg: 0, xs: "15px" },
                        "& .MuiRating-root .MuiRating-iconFilled": {
                          color: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor + " !important" : colors.basics.primary,
                        },
                        "& .MuiRating-iconHover": {
                          color: colors.basics.primary,
                        },
                        '& svg': {
                          width: "15px !important",
                          height: "15px !important",
                        }
                      }
                      }
                    >

                      {/* <LocationIconBlack /> */}
                      <Typography
                        variant="body2"
                        sx={{ fontSize: { sm: "18px !important", xs: "14px !important" } }}
                        color={colors.grey[10]}
                        lineHeight={{ sm: "24PX", xs: "140%" }}
                      >
                        {capitalizeFirstLetterEachWords(isEmpty(item?.HotelInfo?.resort_name?.replace(/&amp;/g, '&'))) + "     "}
                        {/* {data.hotel_id} */}
                      </Typography>
                    </Box>
                  }
                  {rating !== 0 &&
                    <Box
                      display={{ xs: "flex", lg: "block", xl: "flex" }}
                      alignItems="center"
                      gap={1}
                      order={{ xs: 1, sm: 2 }}
                      sx={{
                        textAlign: { xs: "left", sm: "center" },
                        mt: { lg: 0, xs: "0px" },
                        "& .MuiRating-root .MuiRating-iconFilled": {
                          color: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor + " !important" : colors.basics.primary,
                        },
                        "& .MuiRating-iconHover": {
                          color: colors.basics.primary,
                        },
                      }}
                    >
                      <Rating
                        sx={{ fontSize: "16px" }}
                        emptyIcon={
                          <StarIcon style={{ opacity: 0.55, }} fontSize="inherit" />
                        }
                        value={rating}
                        precision={hotel_classification === "2" ? 0.5 : 1}
                        readOnly={true}
                      />
                      <Box ml={{ xs: "auto", sm: 0 }} hidden={Number(platinumHotel) === 0}>
                        <Image
                          src={platinumLogo}
                          alt="logo"
                          // height="40px"
                          // width="100%"
                          style={{ width: windowWidth > 376 ? "130px" : "110px", height: "40px" }}
                        />
                      </Box>
                    </Box>
                  }

                </Box>
                <Box sx={{ mt: "8px" }}>

                  {data.tripAdvisor?.reviews_rating && (
                    <CircleRating value={Number(data.tripAdvisor?.reviews_rating)} />
                  )}
                </Box>
              </Box>
            </Box>

            <Box
              mt="8px"
              sx={{
                "& p": {
                  fontFamily: "Raleway",
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: { lg: 16, xs: 14 },
                  lineHeight: "140%",
                  color: colors.basics.black,
                },
                fontFamily: "Raleway",
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: { lg: 14, xs: 14 },
                lineHeight: "140%",
                color: colors.basics.black,
              }}
              dangerouslySetInnerHTML={{ __html: data?.quickDescription }}
            />

            <Box display="flex" justifyContent="space-between" width="100%" mb="15px" mt="15px" sx={{
              flexDirection: { lg: windowWidth > 1024 ? "row" : "column", xs: windowWidth < 376 ? "row" : "row" },
              gap: 1,
            }} >

              {/* LEFT SIDE */}
              <Box display="flex" flexDirection="column" gap="6px" minWidth={0}>

                {/* DATE + NIGHTS */}

                {flightRoom?.searchCriteria?.date[0] &&
                  < Box display="flex" alignItems="center" gap="4px">
                    {/* <CalenderIcon style={{ fontSize: 16 }} /> */}
                    <Typography
                      variant="subtitle2"
                      color={colors.basics.black}
                      fontSize="14px"
                      fontWeight={600}
                      fontFamily="Raleway"
                      display="flex"
                      alignItems="center"
                    >
                      {dayjs(flightRoom?.searchCriteria?.date[0], "DD/MM/YYYY").format("DD MMM YY")}
                      &nbsp;•&nbsp;
                      {sortRoom(data, filters)[0]?.days_spent} nights
                    </Typography>
                  </Box>}

                {/* AIRPORT */}
                <Box display="flex" alignItems="center" gap="4px">
                  {/* <AiroplaneIcon style={{ fontSize: 16 }} /> */}
                  <Typography
                    variant="subtitle2"
                    color={colors.basics.black}
                    fontSize="14px"
                    fontWeight={600}
                    fontFamily="Raleway"
                  >{
                      holidayPackage?.FlightDetails?.outbound?.flights[0]?.depart_airport_city ||
                      holidayPackage?.FlightDetails?.outbound?.flights[0]?.depart_airport_name
                    }
                  </Typography>
                </Box>

                {/* MEAL PLAN */}
                <Box display="flex" alignItems="center" gap="4px">
                  {/* <InclusiveIcon style={{ fontSize: 16 }} /> */}
                  <Typography
                    variant="subtitle2"
                    color={colors.basics.black}
                    fontSize="14px"
                    fontWeight={600}
                    fontFamily="Raleway"
                    dangerouslySetInnerHTML={{
                      __html: RoomMealWrapper(formatRoomType(sortRoom(data, filters)[0]?.meal_name)),
                    }}
                  />
                </Box>

              </Box>

              <Box display="flex" alignItems="flex-end">
                <Box width="100%">
                  <Box width="100%" display="flex">
                    <Typography sx={{
                      fontFamily: "Raleway",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: { sm: '14px !important', xs: '14px !important' },
                      lineHeight: "130%",
                      mt: "8px"
                    }}>
                      From &nbsp;
                    </Typography>
                    <Typography sx={{
                      fontFamily: "El Messiri",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: { sm: '26px !important', xs: windowWidth < 376 ? '20px !important' : '24px !important' },
                      lineHeight: "31px",
                    }}>

                      {/* {signForPricing + addCommasToNumber(Number(packagePrice))} */}
                      {flightRoom?.searchCriteria?.destination?.discountPrice.isDiscountUK && process.env.REACT_APP_PROJECT_COUNTRY === "uk" && isDiscountValidDate()
                        ? `${signForPricing}${addCommasToNumber(formatPrice(String(calculatePerPersonPrice(roundPrice(unroundedPrice), totalGuests))))}`
                        : flightRoom?.searchCriteria?.destination?.discountPrice.isDiscountIE && process.env.REACT_APP_PROJECT_COUNTRY === "ie" && isDiscountValidDate() ?
                          `${signForPricing}${addCommasToNumber(formatPrice(String(calculatePerPersonPrice(roundPrice(unroundedPrice), totalGuests))))}` :
                          `${signForPricing}${addCommasToNumber(Number(roundedPrice))}`}
                    </Typography>
                    <Typography
                      mx={0}
                      sx={{
                        fontFamily: "El Messiri",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: { sm: '26px !important', xs: windowWidth < 376 ? '20px !important' : '24px !important' },
                        lineHeight: "31px",
                      }}
                    // variant="h1"
                    // fontWeight={600}
                    >
                      &nbsp;pp
                    </Typography>
                  </Box>

                </Box>
              </Box>
            </Box>


            <Box display={{ sm: "flex", xs: "flex" }}>
              <Button
                onClick={handleMoreDetails}
                className="btn-olb-view-hotel"
                sx={{
                  width: "100%",
                  height: "100%",
                  fontWeight: 700,
                  background: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor : colors.basics.primary,
                  color: colors.basics.white,
                  '&:hover': {
                    background: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor : colors.basics.primary,
                    color: colors.basics.white,
                  },
                }
                }
              >
                View Deal
              </Button>
            </Box>
          </Box>
        </Card >
      ) : (
        <Box sx={{ border: `1px solid ${colors.border.grey}`, borderRadius: "10px", height: "100%", width: "100%", maxWidth: "100%", minWidth: 0, overflow: "hidden", boxSizing: "border-box", display: "flex", flexDirection: "column" }} >
          <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, flex: 1, display: "flex", flexDirection: "column" }}>
            <Box sx={{
              position: "relative",
              width: "100%",
              maxWidth: "100%",
              overflow: "hidden",
              "& .slick-dots": {
                bottom: "12px !important",
                display: "flex !important",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
              },

              "& .slick-dots li": {
                width: "auto",
                height: "auto",
                margin: 0,
              },

              "& .slick-dots li div": {
                transition: "all 0.25s ease",
              },

              // INACTIVE dots - small
              "& .slick-dots li:not(.slick-active) div": {
                width: "6px !important",
                height: "6px !important",
                opacity: 0.45,
              },

              // ACTIVE dot - bigger
              "& .slick-dots li.slick-active div": {
                width: "9px !important",
                height: "9px !important",
                opacity: 1,
                background: "white",
                alignItems: "center",
              },
            }}>
              <Box
                sx={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "4px",
                  // width: "20%",
                  // ml: 2
                }}
              >
                {data?.offerDetails &&
                  data?.offerDetails?.length > 0 &&
                  (() => {
                    const uniqueSubTitles = new Set<string>(); // To track unique subtitles
                    return data?.offerDetails?.slice(0, 2).map((d: any, i: number) => {
                      if (d?.subTitle && !uniqueSubTitles.has(d?.subTitle)) {
                        uniqueSubTitles.add(d.subTitle); // Add to the set
                        const offerText = addSpace(d?.subTitle);
                        const truncatedText = offerText && offerText.length > 36
                          ? offerText.substring(0, 36) + '...'
                          : offerText;
                        return (
                          <Box
                            key={i} zIndex={9}
                          >
                            <Chip
                              label={
                                <Typography
                                  variant="subtitle1"
                                  color={Number(platinumHotel) !== 0 ? ` ${colors.basics.plataniumGreenColor} !important` : ` ${colors.basics.primary} !important  `}
                                  fontSize={"12px !important"}
                                  fontWeight={500}
                                  lineHeight={"1.2"}
                                  sx={{
                                    padding: "6px",
                                    maxWidth: { xl: "250px", lg: "210px", xs: "100%" },
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                  zIndex={999}
                                  noWrap
                                >
                                  {capitalizeFirst(truncatedText)}
                                </Typography>
                              }
                              sx={{
                                background: colors.basics.white,
                                border: Number(platinumHotel) !== 0 ? `1px solid ${colors.basics.plataniumGreenColor}` : `1px solid ${colors.basics.primary}  `,
                                height: "auto",
                                "& .MuiChip-label": { p: 0 },
                                borderRadius: "100px!important",
                              }}
                            />
                          </Box>
                        );
                      }
                      return <React.Fragment key={i}></React.Fragment>; // Render nothing for duplicates
                    });
                  })()}
              </Box>

              {/* Slider Code Start */}
              {data?.VendorImages?.length > 0 ? (
                <Slider {...GridSliderSettings}>
                  {data?.VendorImages?.map((img, i) => (
                    <Box key={i} sx={{ height: "100%", minHeight: "186px !important" }}>
                      <Image
                        src={img?.VendorImage?.printed_image_url || "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif"}
                        alt={`image-${i}`}
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src =
                            "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif";
                        }}
                        style={{
                          width: "100%",
                          height: "100%",          // crucial: fill the slide height
                          objectFit: "cover",
                          display: "block",
                          borderTopLeftRadius: '10px !important',
                          borderTopRightRadius: '10px !important',
                        }}
                      />
                    </Box>
                  ))}
                </Slider>
              ) : (<CardMedia
                component="img"
                height="186"
                image={
                  data?.image_name ||
                  "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif"
                }
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src =
                    "https://clients.cylindo.com/viewer/3.x/v3.0/documentation/img/not_found.gif";
                }}
                alt={data?.hotel_name}
                onClick={() => {
                  handleMoreDetails()
                }}
                sx={{ width: "100%", maxWidth: "100%", objectFit: "cover" }}
              />)}
              {/* Slider Code End */}

            </Box>
            <CardContent sx={{ backgroundColor: index % 2 === 0 ? colors.basics.white : "transparent", display: "flex", flexDirection: "column", flexGrow: 1, justifyContent: "space-between" }}>
              <Box display="flex" flexDirection="column" gap={1}>
                {rating !== 0 && (<Box display="flex" alignItems="center"
                  gap={1}
                  sx={{
                    "& .MuiRating-root .MuiRating-iconFilled": {
                      color: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor + " !important" : colors.basics.primary,
                    },
                    "& .MuiRating-iconHover": {
                      color: colors.basics.primary,
                    },
                  }}>
                  <Rating
                    sx={{ fontSize: "16px", color: colors.basics.primary }}
                    emptyIcon={
                      <StarIcon style={{ opacity: 0.55, }} fontSize="inherit" />
                    }
                    value={rating}
                    precision={hotel_classification === "2" ? 0.5 : 1}
                    readOnly={true}
                  />
                </Box>)}
                <Box>
                  <Typography
                    sx={{
                      cursor: "pointer",
                      textTransform: "capitalize",
                      '&:hover': {
                        textDecoration: "underline",
                        color: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor : colors.basics.primary,
                        textTransform: "capitalize"
                      },
                    }}
                    className='btn-olb-view-hotel'
                    onClick={() => handleMoreDetails()}
                    lineHeight={"1.2"}
                    variant="h1"
                    fontSize={{ sm: "24px", xs: "22px" }}
                    dangerouslySetInnerHTML={{ __html: capitalizeFirstLetterEachWords(isEmpty(data?.hotel_name)) }}
                  />
                  {data.tripAdvisor?.reviews_rating && (
                    <CircleRating value={Number(data.tripAdvisor?.reviews_rating)} />
                  )}
                </Box>

                <Box
                  display="flex"
                  gap={1}
                  sx={{
                    "& .MuiRating-root .MuiRating-iconFilled": {
                      color: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor + " !important" : colors.basics.primary,
                    },
                    "& .MuiRating-iconHover": {
                      color: colors.basics.primary,
                    }
                  }
                  }
                >

                  {/* <LocationIconBlack /> */}
                  <Typography
                    variant="body2"
                    sx={{ fontFamily: "Raleway", fontSize: "14px !important" }}
                    color={colors.basics.black}
                    lineHeight={"1.2"}
                    fontWeight={400}
                  >
                    {capitalizeFirstLetterEachWords(isEmpty(item?.HotelInfo?.resort_name?.replace(/&amp;/g, '&'))) + "     "}
                    {/* {data.hotel_id} */}
                  </Typography>
                </Box>


              </Box>
              <Box display="flex" flexDirection="column" sx={{ mt: "auto", pt: { sm: 2, xs: 0 } }} >
                <Box display="flex" justifyContent="space-between" width="100%" sx={{ mt: "auto" }}>
                  <Box display="flex" flexDirection="column">
                    <Typography
                      variant="subtitle2"
                      color={colors.basics.black}
                      fontSize="14px"
                      fontWeight={600}
                      fontFamily="Raleway"
                      display="flex"
                      alignItems="center"
                    >
                      {sortRoom(data, filters)[0]?.days_spent} nights
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      color={colors.basics.black}
                      fontSize="14px"
                      fontWeight={600}
                      fontFamily="Raleway"
                      display="flex"
                      alignItems="center"
                      dangerouslySetInnerHTML={{
                        __html: RoomMealWrapper(formatRoomType(sortRoom(data, filters)[0]?.meal_name)),
                      }}
                    >
                    </Typography>
                  </Box>
                  <Box display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                  >
                    <Box display="flex" alignItems="flex-end">
                      <Typography sx={{
                        fontFamily: "Raleway",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "14px",
                        lineHeight: "31px",
                      }}>
                        From &nbsp;
                      </Typography>
                      <Typography sx={{
                        fontFamily: "El Messiri",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: { sm: '26px !important', xs: '24px !important' },
                        lineHeight: "31px",
                      }}>

                        {/* {signForPricing + addCommasToNumber(Number(packagePrice))} */}
                        {flightRoom?.searchCriteria?.destination?.discountPrice.isDiscountUK && process.env.REACT_APP_PROJECT_COUNTRY === "uk" && isDiscountValidDate()
                          ? `${signForPricing}${addCommasToNumber(formatPrice(String(calculatePerPersonPrice(roundPrice(unroundedPrice), totalGuests))))}`
                          : flightRoom?.searchCriteria?.destination?.discountPrice.isDiscountIE && process.env.REACT_APP_PROJECT_COUNTRY === "ie" && isDiscountValidDate() ?
                            `${signForPricing}${addCommasToNumber(formatPrice(String(calculatePerPersonPrice(roundPrice(unroundedPrice), totalGuests))))}` :
                            `${signForPricing}${addCommasToNumber(Number(roundedPrice))}`}
                      </Typography>
                      <Typography
                        mx={0}
                        sx={{
                          fontFamily: "El Messiri",
                          fontStyle: "normal",
                          fontWeight: 500,
                          fontSize: { sm: '26px !important', xs: '24px !important' },
                          lineHeight: "31px",
                        }}
                      >
                        &nbsp;pp
                      </Typography>
                    </Box>

                  </Box>
                </Box>
                <Button
                  onClick={handleMoreDetails}
                  className="btn-olb-view-hotel"
                  sx={{
                    width: "100%",
                    height: "100%",
                    background: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor + "!important" : colors.basics.primary + "!important",
                    fontWeight: 700,
                    mt: "8px",
                    "&:hover": {
                      background: Number(platinumHotel) !== 0 ? colors.basics.plataniumGreenColor + "!important" : colors.basics.primary + "!important",
                      color: colors.basics.white,
                    },
                  }}
                >
                  View Deal
                </Button>
              </Box>

            </CardContent>
          </Box>
        </Box>
      )}
    </>
  );
};